import { render, staticRenderFns } from "./display-fields.vue?vue&type=template&id=78e2113f"
import script from "./display-fields.vue?vue&type=script&lang=js"
export * from "./display-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports